export default __webpack_public_path__ + "static/345-c74381b748645293d2fc4a0197eb29c0.gif";